'use strict';

var React = require('react');

/**
 * Returns the preferred color scheme of the user
 */ const usePreferredColorScheme = ()=>{
    const [preferredColorScheme, setPreferredColorScheme] = React.useState("light");
    const [isPrefersDark, setIsPrefersDark] = React.useState(false);
    React.useEffect(()=>{
        const mediaQuery = window?.matchMedia("(prefers-color-scheme: dark)");
        setIsPrefersDark(mediaQuery?.matches || false);
        setPreferredColorScheme(mediaQuery?.matches ? "dark" : "light");
        const onChange = (event)=>{
            setIsPrefersDark(event.matches);
            setPreferredColorScheme(event.matches ? "dark" : "light");
        };
        mediaQuery?.addEventListener("change", onChange);
        return ()=>mediaQuery?.removeEventListener("change", onChange);
    }, []);
    const isPrefersLight = !isPrefersDark;
    return {
        preferredColorScheme,
        isPrefersDark,
        isPrefersLight
    };
};

exports.usePreferredColorScheme = usePreferredColorScheme;
//# sourceMappingURL=usePreferredColorScheme.cjs.map
